// components/host-badge-helpers.js: pure label rules for the host badge.
//
// Extracted so node:test (which doesn't transform JSX) can cover the
// badge's label behavior, Phase 3 #9 adds a literal visible "host" text
// label alongside the existing crown SVG. HostCrownBadge consumes both.

/**
 * The visible text label rendered next to the crown for the host
 * occupant. Lowercase to match the tone of the sibling "you" pill.
 *
 * @returns {string}
 */
export function hostLabelText() {
  return 'host';
}

/**
 * The screen-reader label for the host badge as a whole (crown + text).
 *
 * @returns {string}
 */
export function hostBadgeAriaLabel() {
  return 'Room host';
}

/**
 * B3b A1: the badge's accessible name. The badge sits right after the
 * avatar circle (which already announces the player's initial), so the
 * badge itself must announce exactly "Host" — the old "Room host" label
 * read out as "HHost" (avatar initial plus label run together).
 *
 * @returns {string}
 */
export function hostBadgeShortLabel() {
  return 'Host';
}
